import * as types from "../types/cancellationReason.types";
import { 
  getList,
  getSingle,
  postAdd,
  patchEdit,
  deleteRemove,
} from "../../services/cancellationReason.service";
import { validationErrors } from "../../utils/Helpers";

export const cancellationReasonListAction = (data='') => {
  return async (dispatch, getState) => {
    try {
      await getList(getState().authReducer.token, getState().authReducer.user.id, data)
      .then((res) => {
        if (res.data.code === 200) {
          dispatch({
            type: types.SET_LIST_DATA,
            payload: res.data.data,
          });
        }
      })
      ;
    } catch (e) { validationErrors(e) }
  };
};


export const findOneAction = (id) => {
  return async (dispatch, getState) => {
    try {
      return getSingle(getState().authReducer.token, getState().authReducer.user.id, id);
    } catch (e) { validationErrors(e) }
  };
};

export const postAction = (data, id) => {
  return async (dispatch, getState) => {
    try {
      return postAdd(getState().authReducer.token, getState().authReducer.user.id, data, id);
    } catch (e) {
      validationErrors(e);
    }
  };
};

export const patchAction = (data, id) => {
  return async (dispatch, getState) => {
    try {
      return await patchEdit(getState().authReducer.token, getState().authReducer.user.id, data, id);
    } catch (e) {
      validationErrors(e);
    }
  };
};

export const deleteAction = (id) => {
  return async (dispatch, getState) => {
    try {
      return await deleteRemove(getState().authReducer.token, getState().authReducer.user.id, id);
    } catch (e) { validationErrors(e); }
  };
};

